import styled from 'styled-components'
import { Button, Col, colors, Message, Row } from '../components'
import { device } from '../device'
import { days } from '../state/filter'

const Container = styled.div<{ disabled?: boolean }>`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  padding: 1rem 0.75rem;
  background-color: ${colors.DayButtons.containerBackground};
  margin-bottom: -4px;
`

const ButtonCol = styled(Col)`
  align-items: stretch;
  flex-direction: column;
  margin: 0 0.25rem;
  height: 30px;
  width: 30px;

  @media ${device.mobileS} {
    height: 40px;
    width: 40px;
  }

  @media ${device.mobileM} {
    height: 48px;
    width: 48px;
  }
`

const DayButton = styled(Button)<{ activeDay?: boolean }>`
  ${(props) =>
    props.activeDay
      ? `
  background-color: ${colors.DayButtons.activeBg};
  color: ${colors.DayButtons.activeText};
  `
      : `
  background-color: ${colors.DayButtons.buttonBackground};
  border: 2px solid ${colors.DayButtons.border};
  color: ${colors.white};
  `}

  padding: 0;
  border-radius: 35px;
  font-size: 18px;
`

type Props = {
  disabled?: boolean
  day: string
  onDayClick: (day: string) => void
}

const DayButtons = ({ disabled, day, onDayClick }: Props) => (
  <Container disabled={disabled}>
    <Row>
      {days.map((dayItem) => (
        <ButtonCol key={dayItem}>
          <DayButton
            activeDay={dayItem === day}
            onClick={() => {
              onDayClick(dayItem)
            }}
          >
            <Message id="DAY" data={dayItem} />
          </DayButton>
        </ButtonCol>
      ))}
    </Row>
  </Container>
)

export default DayButtons
